import $ from 'jquery';
import utils from '@bigcommerce/stencil-utils';
import swal from 'sweetalert2';
import _ from 'lodash';

export default function(){

}



// WEBPACK FOOTER //
// ./assets/js/theme/halothemes/haloStickyAddToCart.js